import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.68 11.59a3.13 3.13 0 0 0-4.35 0 .75.75 0 0 1-1.06 0 .74.74 0 0 1 0-1.06 4.57 4.57 0 0 1 6.47 0 .75.75 0 1 1-1.06 1.06m-2.73 2.97a.81.81 0 1 0 1.62 0 .81.81 0 1 0-1.62 0m-7.54-7.83a.75.75 0 0 1 0-1.06 3.08 3.08 0 0 0 0-4.35.75.75 0 0 1 1.06-1.06 4.57 4.57 0 0 1 0 6.47.74.74 0 0 1-1.06 0M8.63 3.24a.81.81 0 1 0 1.62 0 .81.81 0 1 0-1.62 0M22.38.81a.81.81 0 1 0 1.62 0 .81.81 0 1 0-1.62 0m-.27 5.66a.81.81 0 1 0 1.62 0 .81.81 0 1 0-1.62 0m-6.46 1.88a.75.75 0 0 1 0-1.06l5.12-5.12a.75.75 0 0 1 1.06 1.06l-5.12 5.12a.75.75 0 0 1-1.06 0M14 10c-2.21-2.24-5.31-3.64-6.91-2a1.7 1.7 0 0 0-.36.48C6.69 8.51.28 20.52.28 20.52a2.38 2.38 0 0 0 .41 2.79 2.37 2.37 0 0 0 2.78.41l12-6.41a1.8 1.8 0 0 0 .57-.4c1.6-1.61.2-4.7-2.04-6.91m.49 5.4c-.35.36-2.37-.52-3.87-2s-2.37-3.52-2-3.87c.15-.15 1.77-.08 3.88 2 1.89 1.88 2.24 3.63 2.01 3.85Z"
    }, null, -1)
  ]));
}
const entertainmentPartyPopperConfetti = { render };
export {
  entertainmentPartyPopperConfetti as default,
  render
};
//# sourceMappingURL=entertainment-party-popper-confetti.svg.js.map
